import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';

/** V2 표·레거시 문서 표 모두 태그·클래스로 스타일링 */
export const StyleMasterPriceRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': { ...approvalFormTableStyles(theme), minWidth: 800 },
  // 레거시 문서는 행마다 표가 따로라 위아래 테두리가 겹침
  '& table + table, & div + div > table': { marginTop: -1 },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& th.bg-info': { fontWeight: 600 },
  // 변경후 칸 강조 — 레거시 문서는 bg-danger
  '& .after, & .bg-danger': {
    backgroundColor: 'var(--dk-danger-soft, #fef1f2)',
    fontWeight: 600,
  },
}));
